import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';

import { TableModule } from 'primeng/table';
import { ColumnService } from '../../../../@core/services/column.service';

@Component({
  selector: 'app-formly-data-table-document-import-line-items',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    TableModule
  ],
  templateUrl: './formly-data-table-document-import-line-items.component.html',
  styleUrl: './formly-data-table-document-import-line-items.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyDataTableDocumentImportLineItemsComponent extends FieldType {
  protected columnService = inject(ColumnService);
  lineItemKeys = signal<string[]>([]);
  lineItems = signal<any[]>([]);


  ngOnInit(): void {
    if (!this.model?.contentAsObject?.lineItems)
      return;
    let lineItems = Array.isArray(this.model?.contentAsObject?.lineItems) ? [...this.model.contentAsObject.lineItems] : [this.model.contentAsObject.lineItems];
    if (lineItems && lineItems.length > 0) {
      this.lineItemsHandler();
      this.lineItemKeys.set(Object.keys(lineItems[0]));
      // this.lineItems.set(lineItems);
    }
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.subscribe(x => {
      let lineItems = Array.isArray(x?.contentAsObject.lineItems) ? [...x.contentAsObject.lineItems] : [x.contentAsObject.lineItems];
      if (lineItems && lineItems.length > 0) {
        this.lineItemsHandler(lineItems);
        // this.lineItems.set(lineItems);
        this.lineItemKeys.set(Object.keys(lineItems[0]));
      }
    });
  }

  lineItemsHandler(dli?: any) {
    const lineItems = dli ?? this.model.contentAsObject?.lineItems;
    let formattedLineItems = [];

    if (Array.isArray(lineItems)) {
      formattedLineItems = lineItems.map(lineItem => {
        const formattedItem: { [key: string]: string | number | null } = {};

        for (const [key, value] of Object.entries(lineItem)) {
          if (value && typeof value === 'object' && !Array.isArray(value)) {
            // Format nested objects (e.g., unit)
            formattedItem[key] = Object.entries(value)
              .map(([nestedKey, nestedValue]) => `${nestedKey}: ${String(nestedValue)}`)
              .join(', '); // Custom separator
          } else if (typeof value === 'string' || typeof value === 'number' || value === null) {
            // Handle valid primitive values, asserting type explicitly
            formattedItem[key] = value as string | number | null;
          } else {
            // Convert other types to strings as fallback
            formattedItem[key] = String(value);
          }
        }

        return formattedItem;
      });
    }

    this.lineItems.set(formattedLineItems);
  }
}
